/* eslint-disable no-unused-expressions */
import {
  BaSeBreakpointContext,
  BaSeHeading5,
  BaSeParagraph,
  BaSeRadio,
  BaSeSmall2,
  BaSeTheme,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React, { useContext, useEffect, useState } from 'react';
import Button from '../../components/button';
import { StepContext } from './context/StepContext';
import {
  AlignButton,
  BoxRadio,
  Container,
  Content,
  ContentBox,
  Header,
} from './johari-styled';

export const Avaliacao = ({ dataStep, settings }) => {
  const cache = Sebrae.StorageUtil.inTemporaryStore();
  const [formState, setFormState] = useState({});
  const [save, setSave] = useState(false);

  const { handleAttention, setCurrentStep, updateStageStatus } =
    useContext(StepContext);

  const validToNext = React.useCallback(
    (data) => {
      const isValid = Object.values(data).every((value) => value !== null);

      if (isValid) {
        updateStageStatus('AVALIAÇÃO');
      }
    },
    [updateStageStatus],
  );
  useEffect(() => {
    const storedState = cache.getItem('@empretec:avaliação');
    if (storedState) {
      setFormState(JSON.parse(storedState));
      validToNext(JSON.parse(storedState));
    } else {
      // Definir opções padrão aqui
      const defaultState = {};
      dataStep?.questions.forEach((domain) => {
        defaultState[domain.id] = null;
      });
      setFormState(defaultState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (domainId, optionId) => {
    setFormState((prevFormState) => ({
      ...prevFormState,
      [domainId]: optionId,
    }));
  };

  const onValidateOptionsSelected = React.useCallback(() => {
    const isValid = Object.values(formState).every((value) => value !== null);
    if (!isValid) {
      handleAttention('Campo obrigatório não informado.');
      setSave(true);
      return;
    }
    setCurrentStep((prev) => prev + 1);
    validToNext(formState);
  }, [formState, handleAttention, setCurrentStep, validToNext]);

  useEffect(() => {
    cache.setItem('@empretec:avaliação', JSON.stringify(formState));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState]);

  const breakpointController = React.useContext(BaSeBreakpointContext);

  const scrollToNext = () => {
    if (!breakpointController.inTablet) {
      window.scrollBy({
        top: window.innerHeight * 0.44,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Container>
      <Header>
        <BaSeHeading5
          isBold
          color={BaSeTheme.colors.institucionais.cinzaSebrae97}
        >
          Como me comporto?
        </BaSeHeading5>

        <BaSeHeading5 color={BaSeTheme.colors.institucionais.cinzaSebrae75}>
          Avalie minhas características comportamentais.
        </BaSeHeading5>
      </Header>
      <Content>
        <ContentBox>
          <BaSeParagraph
            isBold
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
          >
            Se você fosse pontuar como eu demonstro ou não essas
            características, como você avaliaria meu comportamento em relação a
            cada uma?
          </BaSeParagraph>
        </ContentBox>

        {dataStep?.questions?.map((domain, indexD) => (
          <ContentBox key={domain.id}>
            <BaSeParagraph
              color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            >
              {indexD + 1}. <strong>{domain.name}:</strong> {domain.description}
            </BaSeParagraph>
            <BoxRadio nome={dataStep?.name}>
              {domain.options.map(({ option, index }) => (
                <div key={option.id}>
                  <BaSeRadio
                    key={option.id}
                    checked={formState[domain.id] === option.id}
                    onChange={() => {
                      scrollToNext();
                      validToNext(formState);
                      handleChange(domain.id, option.id);
                    }}
                    color="default"
                    id={option.id}
                    label={option.description}
                    name={`domain-${domain.id}`}
                    size="small"
                  />
                </div>
              ))}
              {save && formState[domain.id] === null && (
                <BaSeSmall2 color={BaSeTheme.colors.feedbackInterface.erro45}>
                  Campo obrigatório.
                </BaSeSmall2>
              )}
            </BoxRadio>
          </ContentBox>
        ))}
      </Content>
      <AlignButton>
        <Button
          calback={() => setCurrentStep((prev) => prev - 1)}
          value={'VOLTAR'}
          valueSmall={'VOLTAR'}
          withBorder={true}
          color={settings?.tertiaryColor}
          type="tertiary"
          borderColor={settings?.primaryColor}
        />

        <Button
          calback={() => onValidateOptionsSelected()}
          value={'AVANÇAR'}
          valueSmall={'AVANÇAR'}
          withBorder={true}
          color={settings?.tertiaryColor}
          borderColor={settings?.primaryColor}
        />
      </AlignButton>
    </Container>
  );
};
